import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// import PropTypes from 'prop-types';

// Connect
import connect from '../store/connect';
import * as K from "../constants/constants";

// Pages
import ObjectAndGlobalSearch from '../pages/ObjectAndGlobalSearch';
import GlobalSearch from '../components/GlobalSearch';
import NoMatch from '../pages/NoMatch';
import {Helmet} from "react-helmet";
import Questionnaire from "../components/Questionnaire";

function DevHeader() {

	if (process.env.NODE_ENV === "development") {

		return (
			<React.Fragment>
				<Helmet>
					<link type="text/css" rel="stylesheet" href="http://dios.local.cloudnine.se/UI/build/static/css/index.css" />
				</Helmet>
				<Questionnaire />
			</React.Fragment>
		);

	} else {
		return null;
	}
}


class AppRouter extends Component {

	componentDidUpdate() {
		window.scrollTo(0,0);
	}

	render() {
		const realestate_path_param = K.REALESTATE_PATH_PARAM;
		const premisis_path_param = K.PREMISIS_PATH_PARAM;
		const residence_path_param = K.RESIDENCE_PATH_PARAM;

		if (window.epiReactRoute) {
            return (
				<div>
					<ObjectAndGlobalSearch />
				</div>
            );
		}

		return (
			<div>
				<DevHeader />
				<Switch>
					{/* The order make a difference and the reason why the root level is place last */}
					<Route exact path={K.URI_SEARCH} component={GlobalSearch} />
					<Route exact path={realestate_path_param} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${realestate_path_param}:city/`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${realestate_path_param}:city/:objectType`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${realestate_path_param}:city/:objectType/:area`} render={ props => <ObjectAndGlobalSearch {...props}/> } />

					<Route exact path={premisis_path_param} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${premisis_path_param}:city/`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${premisis_path_param}:city/:objectType`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${premisis_path_param}:city/:objectType/:area`} render={ props => <ObjectAndGlobalSearch {...props}/> } />

					<Route exact path={residence_path_param} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${residence_path_param}:city/`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${residence_path_param}:city/:rent`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					<Route exact path={`${residence_path_param}:city/:rent/:area`} render={ props => <ObjectAndGlobalSearch {...props}/> } />
					
					<Route path="/" component={GlobalSearch} />
					<Route component={NoMatch} />
					<Redirect to="/" />

					{/* STYLEGUIDE PAGE */}
					{/*<Route exact path="/styleguide" component={Styleguide} />*/}
				</Switch>
			</div>
		)
	}
}

export default connect(AppRouter, {}, () => ({}) );



// WEBPACK FOOTER //
// ./src/js/router/Router.js